module.exports = __webpack_public_path__ + "img/icon_3_10.a5e87c3f.png";